import IconCashFlow from './assets/icon_income.svg';
import IconInflationProtection from './assets/icon_protection.svg';
import IconDiversification from './assets/icon_diversification.svg';


const potentialBenefitsData = [
  {
    title: 'Cash Flow',
    image: IconCashFlow,
    body: 'Properties earn rental income from tenants. The more stabilized the property or higher its occupancy, the greater the chance of a steady and predictable stream of cash.',
  },
  {
    title: 'Inflation Protection',
    image: IconInflationProtection,
    body: 'Over the long-term, real estate may provide a hedge against inflation, since property values and rental income typically increase during periods of inflation.',
  },
  {
    title: 'Diversification',
    image: IconDiversification,
    body: 'Within a portfolio, real estate can offer diversification to traditional investments such as stocks and bonds.',
  },
];

export default potentialBenefitsData;
